import { LoginStatus } from 'constants/login-status';

import type { DSAvatarProps } from './interfaces';

export const statusesMap = new Map<LoginStatus, DSAvatarProps['status']>([
  [LoginStatus.Online, 'available'],
  [LoginStatus.Offline, 'unknown'],
  [LoginStatus.Away, 'unavailable'],
]);
